module.controller('accountHeaderCtrl', ['$rootScope', '$scope', '$http', 'Session', 'baseURI','$stateParams', '$q', 'accountService', function ($rootScope, $scope, $http, Session, baseURI,$stateParams, $q, accountService){
  $scope.loading = true;

  $scope.openAccount = function(){
    if($rootScope.isMobileView){
      $scope.openAccountSelector = true;
    }
  };

  accountService.initializeAccounts(function(err, accounts){
    if(!err){
      $scope.loading = false;
      $scope.account = accountService.getAccount($stateParams.username);
    }
  });

  $scope.hideAccountAttribute = function(){
  //hide the account attribute if the account isn't verified yet
   if(Session.getEnrollmentErrorCode() === 150){
     return true;
   }
   return false;
 };
}]);




